import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export const ComparisonSection = () => {
  return <section id="comparison" className="w-full py-12 bg-amber-50" data-id="element-16">
      <div className="container mx-auto px-4" data-id="element-17">
        <h2 className="text-2xl md:text-3xl font-bold text-green-900 mb-8 text-center" data-id="element-18">
          How The Daily Foundation Chew™ Compares to Other Leading Brands
        </h2>
        <p className="text-green-900/80 mb-8 text-center max-w-3xl mx-auto" data-id="element-19">
          We know you have options when it comes to your dog's health. Here's
          how we stack up:
        </p>
        <div className="overflow-x-auto mb-8" data-id="element-20">
          <table className="min-w-full border-collapse" data-id="element-21">
            <thead data-id="element-22">
              <tr className="bg-green-900 text-amber-50" data-id="element-23">
                <th className="p-4 text-left" data-id="element-24">Feature</th>
                <th className="p-4 text-center" data-id="element-25">The Daily Foundation Chew™</th>
                <th className="p-4 text-center" data-id="element-26">Zesty Paws</th>
                <th className="p-4 text-center" data-id="element-27">VetriScience</th>
                <th className="p-4 text-center" data-id="element-28">Native Pet</th>
              </tr>
            </thead>
            <tbody data-id="element-29">
              <tr className="border-b border-green-900/10" data-id="element-30">
                <td className="p-4 text-green-900 font-semibold" data-id="element-31">
                  Soil-Based Probiotics
                </td>
                <td className="p-4 text-center text-yellow-700" data-id="element-32">
                  ✓ (Survive stomach acid)
                </td>
                <td className="p-4 text-center text-red-500" data-id="element-33">✗</td>
                <td className="p-4 text-center text-red-500" data-id="element-34">✗</td>
                <td className="p-4 text-center text-red-500" data-id="element-35">✗</td>
              </tr>
              <tr className="border-b border-green-900/10 bg-green-900/5" data-id="element-36">
                <td className="p-4 text-green-900 font-semibold" data-id="element-37">
                  Ancestral Organ Meats
                </td>
                <td className="p-4 text-center text-yellow-700" data-id="element-38">
                  ✓ (Grass-fed, freeze-dried)
                </td>
                <td className="p-4 text-center text-red-500" data-id="element-39">✗</td>
                <td className="p-4 text-center text-red-500" data-id="element-40">✗</td>
                <td className="p-4 text-center text-red-500" data-id="element-41">✗</td>
              </tr>
              <tr className="border-b border-green-900/10" data-id="element-42">
                <td className="p-4 text-green-900 font-semibold" data-id="element-43">
                  Bioavailable Curcumin
                </td>
                <td className="p-4 text-center text-yellow-700" data-id="element-44">
                  ✓ (CurcuVET® - 29x absorption)
                </td>
                <td className="p-4 text-center text-red-500" data-id="element-45">✗</td>
                <td className="p-4 text-center text-red-500" data-id="element-46">✗</td>
                <td className="p-4 text-center text-red-500" data-id="element-47">✗</td>
              </tr>
              <tr className="border-b border-green-900/10 bg-green-900/5" data-id="element-48">
                <td className="p-4 text-green-900 font-semibold" data-id="element-49">
                  Green-Lipped Mussel
                </td>
                <td className="p-4 text-center text-yellow-700" data-id="element-50">
                  ✓ (500mg therapeutic dose)
                </td>
                <td className="p-4 text-center text-red-500" data-id="element-51">✗</td>
                <td className="p-4 text-center text-red-500" data-id="element-52">✗</td>
                <td className="p-4 text-center text-red-500" data-id="element-53">✗</td>
              </tr>
              <tr className="border-b border-green-900/10" data-id="element-54">
                <td className="p-4 text-green-900 font-semibold" data-id="element-55">
                  Dogs Actually Eat It
                </td>
                <td className="p-4 text-center text-yellow-700" data-id="element-56">
                  ✓ (Tastes like a treat)
                </td>
                <td className="p-4 text-center text-yellow-600" data-id="element-57">Mixed</td>
                <td className="p-4 text-center text-red-500" data-id="element-58">Often refused</td>
                <td className="p-4 text-center text-red-500" data-id="element-59">Often refused</td>
              </tr>
              <tr className="border-b border-green-900/10 bg-green-900/5" data-id="element-60">
                <td className="p-4 text-green-900 font-semibold" data-id="element-61">
                  No Digestive Upset
                </td>
                <td className="p-4 text-center text-yellow-700" data-id="element-62">✓</td>
                <td className="p-4 text-center text-red-500" data-id="element-63">
                  Reported issues
                </td>
                <td className="p-4 text-center text-red-500" data-id="element-64">
                  Reported issues
                </td>
                <td className="p-4 text-center text-red-500" data-id="element-65">
                  Reported issues
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="flex justify-center" data-id="element-66">
          <a href="#reviews" className="bg-yellow-700 hover:bg-yellow-800 text-amber-50 font-bold py-3 px-8 rounded-full text-lg shadow-md transition duration-300 inline-block" data-id="element-67">
            LEARN MORE
          </a>
        </div>
      </div>
    </section>;
};